import React from 'react'

import { IManageSEOContext } from './types'

// This Context is used to update the SEO elements in the head of the app
export const Context = React.createContext<IManageSEOContext>({
  onSetSEO: () => {
    // This is to warn devs who fail to wrap their app in the Provider
    console.warn('Missing ManageSEO Context!')
  },
})

export default Context
